import { useSearchParams } from "react-router-dom";

export function useMeasuringMode() {
  const [params, setParams] = useSearchParams();
  const isMeasuring = params.get("measuring") === "true";

  function setIsMeasuring(toggleMeasuringMode: boolean) {
    const newParams = new URLSearchParams(params);
    if (toggleMeasuringMode) {
      newParams.set("measuring", "true");
    } else {
      newParams.delete("measuring");
    }

    setParams(newParams);
  }

  return { isMeasuring, setIsMeasuring };
}
